module.exports = __webpack_public_path__ + "img/stubbees.8c139d4e.png";